import React from 'react'
import Spinner from '../../Spinner/spinner';
import { ToastContainer } from "react-toastify";
import PaginationCom from '../../Pagination/pagination';
import { Button } from '@mui/material';
import UseTeamList from './Hooks/useTeamList';


const TeamList = () => {
  const {
    page,
    count,
    status,
    spinner,
    PER_PAGE,
    listData,
    setPage,
    navigate,
    setStatus,
    setMarketingTeam,
    invitationReSend,
    statusChange,
  } = UseTeamList()

  return (
    <section>
      <ToastContainer />
      {spinner ? <Spinner /> : null}
      <div className="m-t-3 cus-padd cusheight">
        <header>
          <h2 className="page-tittle">Team List</h2>
          <hr />
        </header>

        <p>Total Team : {listData?.length}</p>
        <div className='d-flex justify-content-end align-item-center'>
          <div className='d-flex'>
            <div className='me-2'>
              <select className='form-select me-2' name='status' value={status} onChange={(e) => setStatus(e.target.value)}>
                <option hidden>Status</option>
                <option value={true}>Active</option>
                <option value={false}>In-Active</option>
              </select>
            </div>
            <button className='btn btn-dark' onClick={() => navigate(`add-team`)}>Add Team</button>
          </div>
        </div>
        <table className="table  shadow mt-3">
          <thead className="table-dark">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Mobile No</th>
              <th scope="col">Confirmation Status</th>
              <th scope='col'>Status</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody className='text-center'>

            {
              !listData?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                :
                listData?.map((item, index) => {
                  return (
                    <>
                      <tr key={index}>
                        <th style={{ padding: "0.4rem .5rem" }} scope="row">
                          {PER_PAGE * (page - 1) + index + 1}
                        </th>
                        <td style={{ padding: "0.4rem .5rem" }}>{item?.name}</td>
                        <td style={{ padding: "0.4rem .5rem" }}>{item?.email}</td>
                        <td style={{ padding: "0.4rem .5rem" }}>{item?.mobileNo}</td>
                        <td style={{ padding: "0.4rem .5rem" }}>{item?.status == 'accepted' ? 'Accepted' : 'Pending'}</td>
                        <td style={{ padding: '0.4rem .5rem' }}>
                          <div className="form-check form-switch" style={{ marginLeft: '44%' }}>
                            <input className="form-check-input" role='switch' type="checkbox" checked={item.isActive} onChange={() => statusChange(item)} />
                          </div>
                        </td>
                        <td style={{ padding: "0.4rem .5rem" }}>
                          <Button disabled={item.status == 'accepted'} variant="text" sx={{ color: 'black', fontSize: '12px' }} id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="fa-solid fa-ellipsis-vertical cursor"></i>
                          </Button>
                          <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <a className="dropdown-item cursor" onClick={() => { setMarketingTeam(item) }} data-bs-toggle="modal" data-bs-target="#resend">Resend Invitation</a>
                          </ul>
                        </td>
                      </tr>
                    </>
                  );
                })}
          </tbody>
        </table>
        <div className='w-100 d-flex justify-content-center pb-2'>
          {!listData?.length ? null :
            count > 10 && <PaginationCom setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />}
        </div>
      </div>

      <div className="modal fade" id="resend" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <p>Are you sure !</p>
              <p>You want to send re-send invitation</p>
              <button type="button" className="btn nobtn" data-bs-dismiss="modal">No</button>
              <button type="button" className="btn yesbtn" data-bs-dismiss="modal" onClick={() => invitationReSend()}>Yes</button>
            </div>

          </div>
        </div>
      </div>
    </section>
  )
}

export default TeamList